import { Observable, of } from 'rxjs';

import { LogEntry } from "@core/classes";
import { LogPublisher } from '@shared/models/log.interface';

export class LocalStorageLog implements LogPublisher {
  location = "app-logs";
  
  constructor() {}

  log(logEntry: LogEntry): Observable<boolean> {
    let includeEntries = false;
    let entries: Array<LogEntry> = [];

    try {
      let entriesPresent = localStorage.getItem(this.location);
      if (entriesPresent)
        entries = JSON.parse(entriesPresent) || []

      entries.push(logEntry);
      localStorage.setItem(this.location, JSON.stringify(entries))
      includeEntries = true;
    } catch(error) {
      console.error(entries);
    }

    return of(includeEntries);
  };

  clear() {
    localStorage.removeItem('app-logs');
    return of(true);
  }
}
